import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesDimensionTargetsView } from "src/components/views/erp/common/accounting/managing/SalesDimensionTargetsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/accounting")({
	staticData: { title: i18n.t("accounting"), legacyViewKey: "salesDimensionTargetsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesDimensionTargetsView />;
}
